(function () {
    'use strict';

    angular.module('app').controller('CouponsController', CouponsController);

    CouponsController.$inject = [
        '$rootScope',
        '$scope',
        '$location',
        'blockUI',
        '$uibModal',
        '$filter',
        '$timeout',
        'ExportService',
        'BusinessService',
        'CouponsService',
        'SelectService',
        'SendMessageService',
        'NotifyService',
        'LANGS',
        'SettingsService',
        'ReceiptService',
        '$sce'
    ];

    function CouponsController(
        $rootScope,
        $scope,
        $location,
        blockUI,
        $uibModal,
        $filter,
        $timeout,
        ExportService,
        BusinessService,
        CouponsService,
        SelectService,
        SendMessageService,
        NotifyService,
        LANGS,
        SettingsService,
        ReceiptService,
        $sce
    ) {

        $scope.isParimatch = appConfig.platformParams.main_site.en === 'pmclub.bet';

        $scope.model = {};

        var today = {
            date: moment().endOf('day').utc().toDate(),
            time: moment().endOf('day').utc().toDate()
        };

        $scope.selectedCouponsUserIds = {};

        $scope.params = {
            filterDates: {
                startDate: {
                    date: moment().subtract(1, 'month').utc().toDate(),
                    time: moment().startOf('day').utc().toDate()
                },
                coupon_emission_dt_from: {},
                coupon_emission_dt_to: angular.copy(today),
                coupon_taken_by_customer_dt_from: {},
                coupon_taken_by_customer_dt_to: angular.copy(today),
                coupon_redeem_dt_from: {},
                coupon_redeem_dt_to: angular.copy(today),
                enableCouponEmissionFilter: false,
                enableCouponTakenByCustomerFilter: false,
                enableCouponRedeemFilter: false
            },
            coupons: {
                page: 1,
                count: 50,
                sort_field: 'emission_dt',
                sort_order: 'desc'
            }
        };

        $scope.data = {
            isFilePreparing: false,
            summaryCoupons: {},
            pagerLengths: [10, 20, 50, 100, 200],
            coupon_status: [
                {id: 'all', title: 'All status coupon'},
                {id: 'open', title: 'Open status coupon'},
                {id: 'redeemed', title: 'Redeemed status coupon'},
                {id: 'cancelled', title: 'Cancelled status coupon'}
            ],
            coupon_deleted: [
                {id: 'all', title: 'All status coupon'},
                {id: 'yes', title: 'Coupon deleted yes'},
                {id: 'no', title: 'Coupon deleted no'}
            ],
            coupon_expired: [
                {id: 'all', title: 'All status coupon'},
                {id: 'yes', title: 'Coupon expired yes'},
                {id: 'no', title: 'Coupon expired no'}
            ],
            coupon_added_to_wallet: [
                {id: 'all', title: 'All status coupon'},
                {id: 'yes', title: 'Coupon added to wallet yes'},
                {id: 'no', title: 'Coupon added to wallet no'}
            ]
        };

        $scope.table_cols = [
            {
                visible: true,
                data: [
                    {value: 'code', text: 'code', visible: true},
                    {value: 'external_code', text: 'TEXT_COUPON_BATCH_EXTERNAL_CODE', visible: true, not_sortable: true}
                ]
            },
            {
                visible: true,
                data: [
                    {value: 'title', text: 'TEXT_COUPON_BATCH_NAME', visible: true},
                ]
            },
            {
                visible: true,
                data: [
                    {value: 'alias', text: 'alias_code', visible: true},
                ]
            },
            {
                visible: true,
                data: [
                    {value: 'emission_dt', text: 'emission_dt', visible: true},
                    {value: 'status', text: 'Status', visible: true}
                ]
            },
            {
                visible: true,
                data: [
                    {value: 'emission_type', text: 'emission_type', visible: true, not_sortable: true},
                    {value: 'emission_source', text: 'emission_source', visible: true, not_sortable: true}
                ]
            },
            {
                visible: true,
                data: [
                    {value: 'taken_by_customer_dt', text: 'Coupon taken by customer date', visible: true},
                    {value: 'redeem_dt', text: 'redeem_dt', visible: true},
                    {value: 'cancel_dt', text: 'cancel_dt', visible: true}
                ]
            },
            {
                visible: true,
                data: [
                    {value: 'redeem_type', text: 'redeem_type', visible: true, not_sortable: true},
                    {value: 'redeem_agent', text: 'redeem_agent', visible: true, not_sortable: true}
                ]
            },
            {
                visible: true,
                data: [
                    {value: 'user_id', text: 'Customer', visible: true},
                    {value: 'email', text: 'Customer email', visible: true},
                    {value: 'deleted_by_customer', text: 'deleted_by_customer', visible: true}
                ]
            }
        ];
        $scope.isSupportUserExternalId = false;

        $scope.getLoyaltiesList = SelectService.getLoyaltiesList;

        $scope.getPages = getTotalPaginatedPages;

        var block_batch_coupon_list = blockUI.instances.get('batch_coupon_list');
        SettingsService.GetPlatformParams(function (success, response) {

            if (success) {
                $scope.isSupportUserExternalId = !!response.support_external_id_primary_identifier;

                if ($scope.isSupportUserExternalId) {

                    $scope.table_cols[$scope.table_cols.length - 1].data.splice(($scope.table_cols[$scope.table_cols.length - 1].data.length - 1), 0,
                        {
                            value: 'user_external_id',
                            text: 'Customer external id',
                            visible: true,
                            not_sortable: true
                        });
                }
            }
            initController();
        });

        function initController() {
        }

        function getBatchesList(loyalty_id, callback) {
            var params = {
                page: 1,
                count: 500,
                loyalty: loyalty_id
            };

            $scope.params.filterDates.startDate = {
                date: moment($rootScope.ENV.business.created).startOf('day').utc().toDate(),
                time: moment($rootScope.ENV.business.created).startOf('day').utc().toDate()
            };

            $scope.params.filterDates.coupon_emission_dt_from = angular.copy($scope.params.filterDates.startDate);
            $scope.params.filterDates.coupon_taken_by_customer_dt_from = angular.copy($scope.params.filterDates.startDate);
            $scope.params.filterDates.coupon_redeem_dt_from = angular.copy($scope.params.filterDates.startDate);

            CouponsService.Batches(params, function (success, data) {
                callback(success, data);
            });
        }

        function getCoupons() {
            block_batch_coupon_list.start();

            var params = angular.copy($scope.params.coupons);
            var filterDates = angular.copy($scope.params.filterDates);

            if ($scope.data.currentLoyalty && $scope.data.currentLoyalty.id)
                params.loyalty_id = $scope.data.currentLoyalty.id;

            if ($scope.data.currentBatch && $scope.data.currentBatch.id && $scope.data.currentBatch.id !== '0')
                params.batch_id = $scope.data.currentBatch.id;

            if ($scope.params.filterDates.enableCouponEmissionFilter) {
                params.coupon_emission_dt_from = transformDateForRequest(filterDates.coupon_emission_dt_from);
                params.coupon_emission_dt_to = transformDateForRequest(filterDates.coupon_emission_dt_to);
            }

            if ($scope.params.filterDates.enableCouponTakenByCustomerFilter) {
                params.coupon_taken_by_customer_dt_from = transformDateForRequest(filterDates.coupon_taken_by_customer_dt_from);
                params.coupon_taken_by_customer_dt_to = transformDateForRequest(filterDates.coupon_taken_by_customer_dt_to);
            }

            if ($scope.params.filterDates.enableCouponRedeemFilter) {
                params.coupon_redeem_dt_from = transformDateForRequest(filterDates.coupon_redeem_dt_from);
                params.coupon_redeem_dt_to = transformDateForRequest(filterDates.coupon_redeem_dt_to);
            }

            $scope.selectedCouponsUserIds = {};

            CouponsService.Coupons(params, function (success, response) {
                if (success) {
                    $scope.data.couponsList = response.data;
                    $scope.data.summaryCoupons = response.summary;
                }
                $timeout(function () {
                    block_batch_coupon_list.stop();
                }, 1000);
            });
        }

        function transformDateForRequest(dateTimeStruct) {
            return moment(dateTimeStruct.date).set({
                hour: moment(dateTimeStruct.time).get('hour'),
                minute: moment(dateTimeStruct.time).get('minute'),
                second: moment(dateTimeStruct.time).get('second')
            });
        }

        function getCoupon(code, callback) {
            CouponsService.GetCoupon(code, function (success, response) {
                if (success)
                    callback(true, response);
                else
                    callback(false, response);
            });
        }

        function _doShow() {

            function s() {
                if ($rootScope.ENV.business.tariff) {
                    if ($rootScope.ENV.business.tariff.use_coupons_and_certificates) {
                        getCoupons();

                        $rootScope.TARIFF_LIMITATION.use_coupons_and_certificates = false;
                    } else {
                        $location.path('/series');
                        $rootScope.TARIFF_LIMITATION.use_coupons_and_certificates = true;
                    }
                } else {
                    $timeout(s, 250);
                }
            }

            s();
        }

        $scope.onSeriesExport = function (format) {
            var isExportStopped = false;

            $scope.modalExport = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.export.html',
                controllerAs: 'exportModal',
                controller: function ($uibModalInstance) {
                    $scope.exportModal = this;

                    // Прогресс загрузки в процентах
                    $scope.exportModal.exportProgress = 0.1;

                    // Количество загруженных записей
                    $scope.exportModal.downloadedDataCount = 0;

                    // Все количество загружаемых записей
                    $scope.exportModal.allDataCount = 0;

                    // Признак - находится ли экспорт на паузе
                    $scope.exportModal.isExportPaused = false;

                    $scope.exportModal.onTogglePause = function () {
                        $scope.exportModal.isExportPaused = !$scope.exportModal.isExportPaused;
                        if (!$scope.exportModal.isExportPaused) {
                            exportRequest();
                        }
                    };

                    $scope.exportModal.onStop = function () {
                        isExportStopped = true;
                        $scope.modalExport.close();
                        if ($scope.exportModal.isExportPaused) {
                            handleExportResults();
                        }
                    };

                    $scope.exportModal.onExit = function () {
                        $scope.exportModal.isExportPaused = true;
                        $scope.data.isFilePreparing = false;
                        $uibModalInstance.close();
                    };
                }
            });

            $scope.data.isFilePreparing = true;

            // TODO сделать метод для формирования параметров здесь и при загрузке таблицы
            var params = angular.copy($scope.params.coupons);

            params = Object.assign(params, $scope.params.coupons);

            var filterDates = angular.copy($scope.params.filterDates);

            if ($scope.data.currentLoyalty && $scope.data.currentLoyalty.id)
                params.loyalty_id = $scope.data.currentLoyalty.id;

            if ($scope.data.currentBatch && $scope.data.currentBatch.id && $scope.data.currentBatch.id !== '0')
                params.batch_id = $scope.data.currentBatch.id;

            if ($scope.params.filterDates.enableCouponEmissionFilter) {
                params.coupon_emission_dt_from = transformDateForRequest(filterDates.coupon_emission_dt_from);
                params.coupon_emission_dt_to = transformDateForRequest(filterDates.coupon_emission_dt_to);
            }

            if ($scope.params.filterDates.enableCouponTakenByCustomerFilter) {
                params.coupon_taken_by_customer_dt_from = transformDateForRequest(filterDates.coupon_taken_by_customer_dt_from);
                params.coupon_taken_by_customer_dt_to = transformDateForRequest(filterDates.coupon_taken_by_customer_dt_to);
            }

            if ($scope.params.filterDates.enableCouponRedeemFilter) {
                params.coupon_redeem_dt_from = transformDateForRequest(filterDates.coupon_redeem_dt_from);
                params.coupon_redeem_dt_to = transformDateForRequest(filterDates.coupon_redeem_dt_to);
            }

            var tl = [];

            function generateFile() {
                var file_name = $rootScope.ENV.business.code + '_series-coupons_' + moment().format('YYYY-MM-DD_HH:mm:ss');

                var export_struct = [];

                for (var i in $scope.table_cols) {

                    if ($scope.table_cols[i].visible) {
                        for (var k in $scope.table_cols[i].data) {
                            var text = $scope.table_cols[i].data[k].text,
                                value = $scope.table_cols[i].data[k].value;

                            export_struct.push({
                                text: $filter('translate')(text) || text,
                                value: value
                            });
                        }
                    }
                }

                export_struct.push({
                    text: $filter('translate')('Text_Link'),
                    value: 'coupon_text_link'
                });

                var export_data = [];
                for (var i in tl) {
                    var el = {};
                    for (var k in export_struct) {
                        var a, b;
                        a = export_struct[k].text;

                        switch (export_struct[k].value) {
                            case 'coupon_text_link':
                                var url_code = JSON.parse(JSON.stringify(tl[i]['code']));
                                b = 'https://' + appConfig.platformParams.client_site[$rootScope.LANG] +
                                    '/coupon/show/{0}?lang={1}'.format(url_code, $rootScope.LANG);
                                break;
                            case 'code':
                                var code = tl[i]['code'];
                                b = $filter('limitTo')(code, 4, 0) + '-' + $filter('limitTo')(code, 4, 4) + '-' + $filter('limitTo')(code, 4, 8);
                                break;
                            case 'external_code':
                                b = tl[i]['external_code'] || '';
                                break;
                            case 'user_external_id':
                                b = tl[i]['external_id'] || '';
                                break;
                            case 'user_id':
                                b = '';
                                if (!!tl[i]['customer']) {
                                    b = (tl[i]['customer']['phone'] || '') + ' - ' + (tl[i]['customer']['name'] || '');
                                }

                                break;
                            case 'alias':
                                var code = '';
                                if(
                                    tl[i]['batch'] &&
                                    tl[i]['batch']['alias'] &&
                                    tl[i]['batch']['alias']['code']
                                ) {
                                    code = tl[i]['batch']['alias']['code'];
                                }
                                b = code ? $filter('limitTo')(code, 4, 0) + '-' + $filter('limitTo')(code, 4, 4) + '-' + $filter('limitTo')(code, 4, 8) : '';
                                break;
                            case 'emission_dt':
                                b = $filter('date')(tl[i]['emission_dt'], 'medium', '+0');
                                break;
                            case 'redeem_dt':
                                b = $filter('date')(tl[i]['redeem_dt'], 'medium', '+0');
                                break;
                            case 'cancel_dt':
                                b = $filter('date')(tl[i]['cancel_dt'], 'medium', '+0');
                                break;

                            case 'emission_type':
                                b = '';
                                if (!!tl[i]['emitter_batch']) {
                                    b = $filter('translate')('TEXT_EMMITED_BY_CROSS_BUSINESS');
                                }
                                if (!!tl[i]['emission_transaction']) {
                                    b = $filter('translate')('TEXT_EMMITED_BY_RULE');
                                }
                                if (!!tl[i]['share']) {
                                    b = $filter('translate')('TEXT_EMMITED_BY_SHARE');
                                }

                                break;

                            case 'emission_source':
                                b = '';
                                if (!!tl[i]['emitter_batch']) {
                                    b = tl[i]['emitter_batch']['loyalty_title'];
                                }
                                if (!!tl[i]['emission_transaction']) {
                                    b = tl[i]['emission_transaction']['terminal_title'];
                                }
                                if (!!tl[i]['share']) {
                                    b = tl[i]['share']['user_phone'];
                                }

                                break;

                            case 'redeem_type':
                                b = '';
                                if (!!tl[i]['redeem_transaction']) {
                                    b = $filter('translate')('TEXT_REDEEMED_BY_REGISTER');
                                }
                                break;

                            case 'redeem_agent':
                                b = '';
                                if (!!tl[i]['redeem_transaction']) {
                                    b = tl[i]['redeem_transaction']['terminal_title'];
                                }
                                break;

                            case 'deleted_by_customer':
                                if (tl[i]['cancel_dt'] == 1) {
                                    b = $filter('translate')('deleted_by_customer');
                                } else {
                                    b = '';
                                }

                                break;

                            case 'status' :
                                b = $filter('translate')(tl[i]['status']) || '';
                                break;

                            // case 'emission_type':
                            //     b = $filter('date')(tl[i]['cancel_dt'], 'medium', '+0');
                            //     break;

                            default:
                                b = (tl[i][export_struct[k].value] === null) ? '' : tl[i][export_struct[k].value];
                        }
                        el[a] = b || '';
                    }

                    export_data.push(el);
                }

                $scope.$evalAsync(function ($scope) {
                    $scope.data.isFilePreparing = false;
                });

                switch (format) {
                    case 'XLSX':
                        alasql('SELECT * INTO XLSX("' + file_name + '.xlsx",{headers:true}) FROM ?', [export_data]);
                        break;
                    case 'XLS':
                        alasql('SELECT * INTO XLS("' + file_name + '.xls",{headers:true}) FROM ?', [export_data]);
                        break;
                    case 'CSV':
                        alasql('SELECT * INTO CSV("' + file_name + '.csv",{headers:true, separator:","}) FROM ?', [export_data]);
                        break;
                }
                return void (0);
            }

            // Номер текущей страницы с записями для загрузки
            var currentPage = 0;

            // Загруженные значения для экспорта
            var exportValues = [];

            // Количество записей загружаемых за один запрос к серверу
            var partCount = 200;

            // Массив параметров для запросов к серверу
            var exportParams = ExportService.generateExportParams(params, $scope.data.summaryCoupons.total_rows_count, partCount);

            // Получение следующего массива записей
            function downloadNextPage(exportParams, currentPage) {
                return new Promise(function (resolve) {
                    getCoupons(exportParams[currentPage]).then(function (resp) {
                        exportValues = [...exportValues, resp];
                        currentPage++;
                        ExportService.calculateExportValuesCount($scope, exportValues, $scope.data.summaryCoupons.total_rows_count);
                        if (!isExportStopped
                            && !$scope.exportModal.isExportPaused
                            && exportParams[currentPage]) {
                            downloadNextPage(exportParams, currentPage).then(function (response) {
                                resolve(response);
                            });
                        } else {
                            resolve({currentPage: currentPage});
                        }
                    });
                });
            }

            function getCoupons(params) {
                return new Promise(function (resolve) {
                    CouponsService.Coupons(params, function (success, response) {
                        resolve(response);
                    });
                });
            }

            function exportRequest() {
                downloadNextPage(exportParams, currentPage).then(function (response) {
                    currentPage = response.currentPage;
                    if (isExportStopped || !exportParams[currentPage]) {
                        $scope.modalExport.close();
                        handleExportResults();
                    }
                });
            }

            function handleExportResults() {
                var result = {};
                result.data = [];
                result.summary = {};
                exportValues.forEach(function (value) {
                    result.data = result.data.concat(value.data);
                });
                tl = result.data;
                generateFile();
            }

            exportRequest();
        };

        $scope.onShareCoupon = function (coupon) {
            getCoupon(coupon.code, function (success, response) {
                BusinessService.GetCustomPreference({name: 'coupon_paths'}, function (successSettings, data) {
                    $scope.modalCouponShare = $uibModal.open({
                        animation: true,
                        keyboard: true,
                        size: 'md',
                        backdrop: 'static',
                        templateUrl: 'app/templates/modal.item.share.html',
                        controllerAs: 'popup',
                        controller: function ($uibModalInstance) {
                            var popup = this;

                            popup.coupon = coupon;
                            for (var i in response)
                                popup.coupon[i] = response[i];

                            popup.model = {
                                share: {
                                    text: popup.coupon.batch.public_title + ' ',
                                    tags: 'discount, sale, coupon, gift, ' + appConfig.platformParams.platform_name[$rootScope.LANG] + ', LoyaltyPays',
                                    image: popup.coupon.batch.image ? popup.coupon.batch.image : 'assets/img/dummy_coupon_batch.png',
                                    link: 'https://' + appConfig.platformParams.client_site[$rootScope.LANG] + '/coupon/show/' + coupon.code + '?lang=' +
                                        $rootScope.LANG
                                }
                            };

                            if (successSettings && data.value) {
                                var link = data.value.coupon_path_share;
                                if (link) {
                                    link = link.replaceAll('{{platform}}', appConfig.platformParams.client_site[$rootScope.LANG]);
                                    link = link.replaceAll('{{coupon}}', coupon.code);
                                    link = link.replaceAll('{{lang}}', $rootScope.LANG);
                                    popup.model.share.link = link;
                                }
                            }

                            popup.model.share.title = popup.coupon.batch.public_title;
                            popup.model.share.description = popup.coupon.batch.public_description;

                            popup.onCopyLink = function () {
                                $scope.modalCouponShare.close();
                            };

                            popup.onCancelClick = function () {
                                $scope.modalCouponShare.close();
                            };
                        }
                    });
                });
            });
        };

        $scope.onPrintCoupon = function (coupon) {
            var coupon_block = blockUI.instances.get('coupon_block');
            BusinessService.GetCustomPreference({name: 'coupon_paths'}, function (successSettings, data) {
                coupon_block.start();
                $scope.modalCouponPrint = $uibModal.open({
                    animation: true,
                    keyboard: true,
                    size: 'lg',
                    backdrop: 'static',
                    templateUrl: 'app/templates/modal.item.print.html',
                    controllerAs: 'popup',
                    controller: function ($uibModalInstance) {
                        var popup = this;
                        popup.type = 'coupon';

                        var params = {
                            lang: $rootScope.LANG,
                            qr_code_link: coupon.code,
                            custom_open_link: null
                        }

                        if (successSettings && data.value) {
                            var link = data.value.coupon_path_qr;
                            if (link) {
                                link = link.replaceAll('{{platform}}', appConfig.platformParams.client_site[$rootScope.LANG]);
                                link = link.replaceAll('{{coupon}}', coupon.code);
                                link = link.replaceAll('{{lang}}', $rootScope.LANG);
                                params.qr_code_link = link;
                            }

                            var openLink = data.value.coupon_path_share;
                            if (openLink) {
                                openLink = openLink.replaceAll('{{platform}}', appConfig.platformParams.client_site[$rootScope.LANG]);
                                openLink = openLink.replaceAll('{{coupon}}', coupon.code);
                                openLink = openLink.replaceAll('{{lang}}', $rootScope.LANG);
                                params.custom_open_link = openLink;
                            }
                        }

                        ReceiptService.getCouponView(coupon.id, params, function (success, viewData) {
                            popup.couponView = $sce.trustAsHtml(viewData.data);
                            coupon_block.stop();
                        })

                        popup.onItemPrint = function () {
                            coupon_block.start();
                            ReceiptService.getCouponPdf(coupon.id, params, function (successPdf, res) {
                                if (!successPdf) {
                                    NotifyService.Error('Can not print the receipt', true);
                                    coupon_block.stop();
                                    return;
                                }
                                var binary = atob(res.data.data.replace(/\s/g, ''));
                                var len = binary.length;
                                var buffer = new ArrayBuffer(len);
                                var view = new Uint8Array(buffer);
                                for (var i = 0; i < len; i++) {
                                    view[i] = binary.charCodeAt(i);
                                }
                                var blob = new Blob([view], {type: "application/pdf"});
                                saveAs(blob, `coupon-${coupon.id}.pdf`);
                                coupon_block.stop();
                            })
                        };

                        popup.onCancelClick = function () {
                            $scope.modalCouponPrint.close();
                        };
                    }
                });
            })
        };

        $scope.onCouponDisable = function (coupon) {
            CouponsService.CancelCoupon(coupon.id, function (success, response) {
                if (success)
                    updateItemInList($scope.data.couponsList, response);
            });
        };

        $scope.getTableHeaderClass = function (row) {
            return {
                'sorting_asc': $scope.params.coupons.sort_field == row.value && $scope.params.coupons.sort_order == 'asc',
                'sorting_desc': $scope.params.coupons.sort_field == row.value && $scope.params.coupons.sort_order == 'desc',
                'sorting': !row.not_sortable
            };
        };
        $scope.onFilterCoupons = function (row) {
            getCoupons();
        };
        $scope.onSortOrderChange = function (row) {
            if (!!row.not_sortable) {
                return;
            }
            var field = row.value;

            if ($scope.params.coupons.sort_field == field)
                $scope.params.coupons.sort_order = $scope.params.coupons.sort_order == 'asc' ? 'desc' : 'asc';

            $scope.params.coupons.sort_field = field;
            getCoupons();

        };

        /**
         * Event rice when user change current page (next or prev) or change items count on page
         */
        $scope.onChangeCouponsPager = function () {
            console.log('TablePager onPagerChange', $scope.params.coupons);
            getCoupons();
        };

        /**
         * Выбрать все чекбоксы в таблице
         */
        $scope.onSelectAllCoupons = function () {
            $scope.data.couponsList.forEach(function (coupon) {
                if (coupon.id) {
                    $scope.selectedCouponsUserIds[coupon.id] = !$scope.model.selectedAll;
                }
            });
        };

        $scope.openSendMessagePopup = function () {
            if ($scope.data.currentBatch.id == 0) {
                NotifyService.Warning($filter('translate')('Coupons series not selected'));
            } else {
                SendMessageService.popupSendMessage($scope, $scope.data.currentBatch);
            }
        };

        $rootScope.$watch('LOYALTIES', function (newValue, oldValue) {
            if (newValue && newValue.length > 0) {
                $scope.data.loyaltiesList = angular.copy($rootScope.LOYALTIES);

                if ($rootScope.ENV.filters.global_filter && $rootScope.ENV.filters.global_filter.loyalty_id !== '0') {
                    $scope.data.currentLoyalty = itemByIndex($scope.data.loyaltiesList, $rootScope.ENV.filters.global_filter.loyalty_id);
                } else {
                    $scope.data.currentLoyalty = $scope.data.loyaltiesList[0];
                }
            }
        });

        $scope.$watch('data.currentLoyalty', function (newValue, oldValue) {
            if (newValue) {
                var loyalty_id = $scope.data.currentLoyalty.id;

                $scope.data.currentBatchesList = [{title: 'All coupon series', id: '0'}];
                getBatchesList(loyalty_id, function (success, response) {
                    if (success) {
                        $scope.data.currentBatch = null;
                        $scope.data.currentBatchesList = [];

                        if ($rootScope.COUPONS_BATCHES[loyalty_id] && $rootScope.COUPONS_BATCHES[loyalty_id].data.length > 0)
                            $scope.data.currentBatchesList = angular.copy($rootScope.COUPONS_BATCHES[loyalty_id].data);

                        $scope.data.currentBatchesList.unshift({title: 'All coupon series', id: '0'});
                        $scope.data.currentBatch = $scope.data.currentBatchesList[0];

                        _doShow();
                    }
                });

                // $scope.data.currentLoyalty = newValue;
                $rootScope.ENV.filters.batches_list = {
                    loyalty_id: newValue.id
                };
                $rootScope.ENV.filters.global_filter = {loyalty_id: newValue.id};
                $rootScope.storeENV();

            }
        }, true);

        $scope.$watch('data.currentBatch', function (newValue, oldValue) {
            if (newValue) {
                $scope.params.coupons.page = 1;

                _doShow();
            }
        }, true);

    }
})();
